<template>
  <div class="vab-ad">
    <!-- <el-carousel
      v-if="adList"
      height="60px"
      direction="vertical"
      :autoplay="true"
      :interval="3000"
      indicator-position="none"
    >
      <el-carousel-item v-for="(item, index) in adList" :key="index">
        <el-tag type="warning">Ad</el-tag>
        <a target="_blank" :href="item.url">{{ item.title }}</a>
      </el-carousel-item>
    </el-carousel> -->
    <vab-breadcrumb></vab-breadcrumb>
  </div>
</template>
<script>
  export default {
    name: 'VabAd',
    data() {
      return {
        nodeEnv: process.env.NODE_ENV,
        adList: [],
      }
    },
    created() {
    },
    methods: {
    },
  }
</script>
<style lang="scss" scoped>
  .vab-ad {
    height: 60px;
    padding-right: $base-padding;
    padding-left: $base-padding;
    margin-bottom: -20px;
    line-height: 60px;
    cursor: pointer;

    a {
      color: #999;
    }
  }
</style>
